import { PageEvent } from '@angular/material/paginator'
import { Sort } from '@angular/material/sort'

export interface RekisterinSivu<T> {
  rivit: T[]
  /** Poistamattomien rivien määrä kaikilla sivuilla */
  rivienMaara: number
}

/** Asiakas- ja tuoterekisterin listaus: poistetut piiloon, lajittelu valitun sarakkeen mukaan ja yksi sivu kerrallaan. */
export function suodataLajitteleJaSivuta<T extends { poistettu?: boolean }>(rivit: T[], lajittelu: Sort, sivutus: Pick<PageEvent, 'pageIndex' | 'pageSize'>, vertaa: (a: T, b: T, sarake: string) => number): RekisterinSivu<T> {
  const naytettavat = rivit.filter(rivi => !rivi.poistettu)
  const { active, direction } = lajittelu
  const suunta = direction === 'asc' ? 1 : -1
  const jarjestetyt = active && direction ? [...naytettavat].sort((a, b) => vertaa(a, b, active) * suunta) : naytettavat
  const alku = sivutus.pageIndex * sivutus.pageSize
  return { rivit: jarjestetyt.slice(alku, alku + sivutus.pageSize), rivienMaara: jarjestetyt.length }
}
